import { gsap } from 'gsap';
import { headerHeight } from '../helpers';
import { openMinicart } from './minicart';

if (!window.dAgency) window.dAgency = {};

$(function () {
  const $siteHeader = $('.site-header');
  const $header = $siteHeader.find('.header__container');
  if ($siteHeader <= 0 || $header.length <= 0) return false;

  $('html').css('scroll-padding-top', headerHeight() + 'px');
  $('#PageContainer').css(
    'min-height',
    'calc(100vh - ' + headerHeight() + 'px)',
  );
  $('#CartPopup').css('top', headerHeight() + 'px');

  $(window).on('resize', function () {
    $('html').css('scroll-padding-top', headerHeight() + 'px');
    $('#PageContainer').css(
      'min-height',
      'calc(100vh - ' + headerHeight() + 'px)',
    );
    $('#CartPopup').css('top', headerHeight() + 'px');
  });

  /* ======================== Header ======================== */
  $header.find('.header__left__newsletter-button').on('click', function () {
    if (typeof window.dAgency.showNewsletterPopUp === 'function')
      window.dAgency.showNewsletterPopUp();
  });

  const $cartLink = $header.find('.cart-link');
  if ($cartLink.length) {
    $cartLink.on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      openMinicart();
    });
  }

  /* ======================== Mobile Menu ======================== */
  const $mobileMenu = $header.find('.header__mobile-menu');
  if ($mobileMenu.length > 0) {
    if ($mobileMenu.hasClass('header__mobile-menu--dropdown')) {
      $mobileMenu.find('[data-link-opener]').on('click', function (e) {
        if (e.target.getAttribute('href')) return;

        const drawerAttribute = $(this).data('link-opener');
        const $drawer = $(this)
          .parent()
          .find('[data-level="' + drawerAttribute + '"]');
        if ($drawer.length > 0) {
          $drawer.addClass('open');
          $(this).closest('ul').scrollTop(0);
          $(this).closest('ul').addClass('no-overflow');
        }
      });

      $mobileMenu.find('[data-close-level]').on('click', function () {
        $(this).parent().removeClass('open');
        $(this).closest('ul.no-overflow').removeClass('no-overflow');
      });
    }

    const burgerTop = document.getElementById('burger-bar-top');
    const burgerMiddle = document.getElementById('burger-bar-middle');
    const burgerBottom = document.getElementById('burger-bar-bottom');
    var tl = gsap.timeline();

    $header.find('.header__burger-icon').on('click', function () {
      $mobileMenu.toggleClass('open');
      $('html').css('overflow-y', 'hidden');
      tl = gsap.timeline();
      tl.to(
        burgerTop,
        {
          rotate: 45,
          duration: 1,
          y: 7,
          transformOrigin: 'center',
          ease: 'elastic.out(1, 0.4)',
        },
        0,
      );
      tl.to(
        burgerMiddle,
        {
          scaleX: 0,
          duration: 1,
          opacity: 0,
          transformOrigin: 'center',
          ease: 'elastic.out(1, 0.4)',
        },
        0,
      );
      tl.to(
        burgerBottom,
        {
          rotate: -45,
          duration: 1,
          y: -7,
          transformOrigin: 'center',
          ease: 'elastic.out(1, 0.4)',
        },
        0,
      );
    });

    $('.header__mobile-menu--dropdown__close').on('click', function () {
      $mobileMenu.toggleClass('open');
      $('html').css('overflow-y', '');
        tl = gsap.timeline();
        tl.to(
          burgerTop,
          {
            rotate: 0,
            duration: 1,
            y: 0,
            transformOrigin: 'center',
            ease: 'elastic.out(1, 0.4)',
          },
          0,
        );
        tl.to(
          burgerMiddle,
          {
            scaleX: 1,
            duration: 1,
            opacity: 1,
            transformOrigin: 'center',
            ease: 'elastic.out(1, 0.4)',
          },
          0,
        );
        tl.to(
          burgerBottom,
          {
            rotate: 0,
            duration: 1,
            y: 0,
            transformOrigin: 'center',
            ease: 'elastic.out(1, 0.4)',
          },
          0,
        );
    });

    const $mobileMenuImages = $('.header__mobile-menu__level__image');
    if ($mobileMenuImages.length > 0) {
      $mobileMenuImages.each(function () {
        const $links = $(this).prev();
        $links.css(
          'height',
          'calc(100% - ' + $(this).innerHeight() + 'px - 1rem)',
        );
      });
    }
  }

  /* ======================== Desktop Menu ======================== */
  const $desktopMenu = $header.find('.header__desktop-menu');
  if ($desktopMenu.length > 0) {
    if ($desktopMenu.hasClass('header__desktop-menu--dropdown')) {
      const $dropdownInlineElements = $desktopMenu.find(
        '.header__desktop-menu--dropdown__inline-elements__link',
      );
      $dropdownInlineElements.each(function () {
        if (
          $desktopMenu.hasClass(
            'header__desktop-menu--dropdown--alternative',
          ) &&
          $(this).find('.header__desktop-menu--dropdown__navigation__element')
            .length <= 0
        )
          return;

        $(this).on('mouseenter', function () {
          $(this)
            .find('.header__desktop-menu--dropdown__dropdown-wrapper')
            .addClass('open');
          $header.addClass('force-opacity');
        });

        $(this).on('mouseleave', function () {
          $(this)
            .find('.header__desktop-menu--dropdown__dropdown-wrapper')
            .removeClass('open');
          $header.removeClass('force-opacity');
        });
      });

      if (
        $desktopMenu.hasClass('header__desktop-menu--dropdown--alternative')
      ) {
        const $sliders = $desktopMenu.find(
          '.header__desktop-menu--dropdown__navigation',
        );
        $sliders.each(function () {
          window.dAgency.initDesktopSlider(this, 2);
        });
      } else {
        $desktopMenu
          .find('.header__desktop-menu--dropdown__navigation')
          .each(function () {
            const $mediaContainer = $(this).find(
              '.header__desktop-menu--dropdown__navigation__media',
            );
            const $titleWithImages = $(this).find('[data-image-src]');

            $titleWithImages.on('mouseenter', function () {
              const imgSrc = $(this).data('image-src');
              const $img = $mediaContainer.find('[srcset*="' + imgSrc + '"]');

              $mediaContainer
                .find(
                  '.header__desktop-menu--dropdown__navigation__media__img.active',
                )
                .removeClass('active');
              $img.addClass('active');
            });
          });

        const $menuCarousel = $desktopMenu.find(
          '.header__desktop-menu--dropdown__carousel__blocks',
        );
        if ($menuCarousel.length > 0) {
          $menuCarousel.each(function () {
            const slider = $(this)[0];
            if (slider.scrollWidth <= slider.clientWidth) {
              $(this).css('justify-content', 'center');
            } else {
              window.dAgency.initDesktopSlider(slider, 2);
            }
          });
        }
      }
    } else if ($desktopMenu.hasClass('header__desktop-menu--drawer')) {
      const $firstLevelLinks = $desktopMenu.find(
        '.header__desktop-menu--drawer__inline-elements__link',
      );
      $firstLevelLinks.each(function () {
        $(this).on('mouseenter', function () {
          if ($(window).outerWidth() <= 1024) return;

          $header.addClass('force-opacity');
          $(this).addClass('open');
          $('html').css('overflow-y', 'hidden');
        });

        $(this).on('mouseleave', function () {
          if ($(window).outerWidth() <= 1024) return;

          $header.removeClass('force-opacity');
          $(this).removeClass('open');
          $(this).find('.open').removeClass('open');
          $('html').css('overflow-y', '');
        });
      });

      $desktopMenu
        .find('.header__desktop-menu--drawer__second-level')
        .each(function () {
          $(this).css('height', 'calc(100vh - ' + headerHeight() + 'px)');

          const $level = $(this);
          $(this)
            .find(
              '.header__desktop-menu--drawer__second-level__title.clickable',
            )
            .on('click', function (e) {
              if (e.target.getAttribute('href')) return;

              const levelIndex = $(this).data('submenu');
              $level
                .find(
                  '.header__desktop-menu--drawer__third-level[data-submenu="' +
                    levelIndex +
                    '"]',
                )
                .addClass('open');
            });
        });

      $(this)
        .find('.header__desktop-menu--drawer__third-level')
        .each(function () {
          const $thirdLevel = $(this);
          const $overflowContainer = $(this).find(
            '.header__desktop-menu--drawer__third-level__overflow-container',
          );
          const $goBack = $(this).find(
            '.header__desktop-menu--drawer__third-level__go-back',
          );

          $overflowContainer.css(
            'height',
            'calc(100% - ' + $goBack.outerHeight() + 'px)',
          );
          $goBack.on('click', function () {
            $thirdLevel.removeClass('open');
          });
        });
    }
  }

  /* ==================== Desktop Search PopUp ==================== */
  const $deskSearchBar = $header.find('.header__search-popup');
  if ($deskSearchBar.length > 0) {
    $deskSearchBar.css('top', headerHeight() + 'px');

    const $iconSearch = $header.find('.header__right__element.search');
    if ($iconSearch.length > 0) {
      $iconSearch.on('click', function (e) {
        e.preventDefault();
        $deskSearchBar.toggleClass('open');

        if ($deskSearchBar.hasClass('open')) {
          $deskSearchBar.find('form input[type="text"]').trigger('focus');
        }
      });
    }

    $(window).on('resize', function () {
      if ($(window).outerWidth() <= 1024) {
        $deskSearchBar.removeClass('open');
      } else {
        $deskSearchBar.css('top', headerHeight() + 'px');
      }
    });

    const $closeIcon = $deskSearchBar.find('.header__search-popup__close-icon');
    if ($closeIcon.length > 0) {
      $closeIcon.on('click', function () {
        $deskSearchBar.removeClass('open');
      });
    }
  }
});
